/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ChatParticipantInvitation = zod.object({
  display: zod
    .string()
    .nullable()
    .describe(
      'Full identifier for the invitation creator; masked for other thread members; the profile name (under existing visibility) for actor-keyed entries; null when nothing may be shown',
    ),
  id: zod.uuid().describe('UUID v4 identifier'),
  kind: zod.enum(['email', 'phone', 'actor']),
  status: zod.enum(['open', 'claimed', 'revoked', 'expired']),
});

export type ChatParticipantInvitation = zod.input<typeof ChatParticipantInvitation>;
export type ChatParticipantInvitationOutput = zod.output<typeof ChatParticipantInvitation>;
